import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/selectionlab.webp';
import screenshot_target from '../../../images/letterfunnel/lottewelten.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Lotte Welten"
      firstname="Lotte"
      companyname="Selection Lab"
      competition="TestGorilla en Harver"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/lottewelten.js